export default __webpack_public_path__ + "static/media/PleaseMessage.ab39fe07.png";